import * as z from "zod";

// Define the Option type for dropdown values
const OptionSchema = z.object({
  value: z.string(),
  label: z.string(),
});

export type Option = z.infer<typeof OptionSchema>;

/**
 * Schema for the work form
 * Defines validation rules for all work form fields
 */
export const WorkFormSchema = z
  .object({
    name: z.string().min(1, "Work name is required"),
    description: z.string().optional(),
    documentation: z.string().optional(),
    workTypeId: z.string().optional().nullable(),
    statusId: z.string().optional().nullable(),
    accessLevelId: z.string().optional().nullable(),
    tentativeStartDate: z.date().optional().nullable(),
    tentativeEndDate: z.date().optional().nullable(),
    actualStartDate: z.date().optional().nullable(),
    actualEndDate: z.date().optional().nullable(),
    tentativeBudget: z.number().optional().nullable(),
    approvedBudget: z.number().optional().nullable(),
    assignedTo: z.union([z.string(), OptionSchema]).optional().nullable(),
    orgId: z.string(),
    parentId: z.union([z.string(), OptionSchema]).optional().nullable(),
  })
  .refine(
    (data) => {
      // Skip validation if either date is null/undefined
      if (!data.tentativeStartDate || !data.tentativeEndDate) return true;

      // Ensure tentative end date is after tentative start date
      return data.tentativeEndDate >= data.tentativeStartDate;
    },
    {
      message: "End date must be after start date",
      path: ["tentativeEndDate"],
    },
  )
  .refine(
    (data) => {
      // Skip validation if either date is null/undefined
      if (!data.actualStartDate || !data.actualEndDate) return true;

      // Ensure actual end date is after actual start date
      return data.actualEndDate >= data.actualStartDate;
    },
    { message: "End date must be after start date", path: ["actualEndDate"] },
  );

export type WorkFormValues = z.infer<typeof WorkFormSchema>;
